<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pl-3 pr-3">
            <h2 class="ml-0 mb-0 mt-0">
                <div class="d-flex flex-wrap justify-content-between">
                    <div class="breadcrumbactive">
                        <div>
                            <span>Notification</span>
                            <!-- <div>Teams</div> -->
                        </div>
                    </div>
                </div>
            </h2>
            <div class="create-company-container w-100">
                <div class="main-div">
                    <div class="create-company-header d-flex align-items-center justify-content-between">
                        <span class="fs-14  pl-4 text-white ml-1 fw-500">Notification List</span>
                        <!-- <button @click="scrollDown">scrollDown</button> -->
                    </div>
                    <div class="d-flex flex-col flex-auto min-h-0 relative z-10">
                        <div class="notifyPageSimple-scroll-content notifyBlock">
                            <div class="d-flex flex-auto flex-col z-10 h-full">
                                <div class="notifyPageSimple-wrapper">
                                    <div class="notifyPageSimple-sidebarWrapper permanent closed notifyPageSimple-leftSidebar notifyFlexAuto">
                                        <div class="notifyPageSimple-sidebar border-0 permanent notifyDiv">
                                            <div class="notifyScroll">
                                                <div class="notifyPageSimple-sidebarContent">
                                                    <div class="d-flex flex-col flex-auto h-full px-4 justify-content-center align-items-center">
                                                        <div class="no-data pt-2 d-flex">
                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/add_reminders.svg" class="img-responsive">
                                                        </div>
                                                        <div class="d-flex justify-content-center align-items-center">
                                                            <p class="mt-8 notification-text">Get updated with current progress <br> with Clients and meetings!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="notifyPageSimple-contentWrapper py-2">
                                        <div class="notifyPageSimple-content container notifyScroll">
                                            <div class="notes-list p-4 w-100" style="border-radius: 10px;box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.41);background-color: #fff;">
                                                <div v-if="(ajax_loader && notifications_list.length == 0)" style="width:100%; height:100%;" class="d-flex justify-content-center align-items-center">
                                                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                                                </div>
                                                <div v-else-if="(!ajax_loader && notifications_list.length == 0)" style="width:100%; height:100%;" class="d-flex justify-content-center align-items-center">
                                                    <h6>No Notifications Found</h6>
                                                </div>
                                                <ul v-else class="notes-scroller px-4 py-2" @scroll="infiniteScroll" id="scroller">
                                                    <li class="note-box d-flex align-items-center w-100 p-2" :class="note.is_read ? 'checked' : ''" v-for="(note, note_index) in notifications_list" @click="viewReminder(note.redirection_id, note.goto, note.is_read, note._id, note.is_cancelled)" :key="note_index">
                                                        <div>
                                                            <div style="background-color: rgb(0, 68, 139);height: 55px;width: 55px;border-radius: 100%;" class="d-flex">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/clock_white.svg" v-if="note.img_type == 'follow_up'" class="margin-auto-img" alt="Follow Up" width="30">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/white-calendar-new.svg" v-if="note.img_type == 'event'" class="margin-auto-img" alt="Event" width="30">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/megaphone.svg" v-if="note.img_type == 'task'" class="margin-auto-img" alt="Task" width="30">
                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/bell_icon.svg" v-if="note.img_type == 'reminder'" class="margin-auto-img" alt="Remainder" width="30">
                                                            </div>
                                                        </div>
                                                        <div class="ml-3">
                                                            <div class="fw-500 fs-14">{{note.message}}</div>
                                                            <div class="fs-12 pt-1" style="color: #707070">{{note.type}}</div>
                                                            <!-- <div class="fs-12 pt-1" style="color: #707070">12 Dec 2022 | 08:00 PM </div> -->
                                                            <div class="fs-12 pt-1" style="color: #707070">{{note.create_datetime}}</div>
                                                        </div>
                                                    </li>
                                                </ul>
                                                <div v-if="(ajax_loader && notifications_list.length > 0)" class="d-flex justify-content-center align-items-center pos-loader">
                                                    <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b" style="margin: 0 auto;" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="mt-5 d-flex py-2 overflow-x-auto">
                        <div class="notification-illustrator">
                            <div class="no-data pt-2">
                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/newcrm/add_reminders.svg">
                                <h3 class="mt-15">Notifications</h3>
                            </div>
                        </div>
                        <div class="notes-list p-4 mr-5" style="border-radius: 10px;box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.41);background-color: #fff;">
                            <div v-if="(ajax_loader && notifications_list.length == 0)" style="width:100%; height:100%;" class="d-flex justify-content-center align-items-center">
                                <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                                style="margin: 0 auto;" />
                            </div>
                            <div v-else-if="(!ajax_loader && notifications_list.length == 0)" style="width:100%; height:100%;" class="d-flex justify-content-center align-items-center">
                                <h6>No Notifications Found</h6>
                            </div>
                            <ul v-else class="notes-scroller px-4 py-2" @scroll="infiniteScroll" id="scroller">
                                <li class="note-box d-flex align-items-center w-100 p-2" :class="note.is_read ? 'checked' : ''" v-for="(note, note_index) in notifications_list" @click="viewReminder(note.redirection_id, note.goto, note.is_read, note._id)" :key="note_index">
                                    <div>
                                        <div style="background-color: rgb(0, 68, 139);height: 55px;width: 55px;border-radius: 100%;" class="d-flex">
                                            <img src="/static/images/clock_white.svg" v-if="note.img_type == 'follow_up'" class="margin-auto-img" alt="" width="30">
                                            <img src="/static/images/white-calendar-new.svg" v-if="note.img_type == 'event'" class="margin-auto-img" alt="" width="30">
                                            <img src="/static/images/megaphone.svg" v-if="note.img_type == 'task'" class="margin-auto-img" alt="" width="30">
                                            <img src="/static/images/bell_icon.svg" v-if="note.img_type == 'reminder'" class="margin-auto-img" alt="" width="30">
                                        </div>
                                    </div>
                                    <div class="ml-3">
                                        <div class="fw-500 fs-14">{{note.message}}</div>
                                        <div class="fs-12 pt-1" style="color: #707070">{{note.type}}</div>
                                        <div class="fs-12 pt-1" style="color: #707070">{{note.create_datetime}}</div>
                                    </div>
                                </li>
                            </ul>
                            <div v-if="(ajax_loader && notifications_list.length > 0)" class="d-flex justify-content-center align-items-center w-100 pos-loader">
                                <half-circle-spinner :animation-duration="1000" :size="50" color="#00448b"
                                            style="margin: 0 auto;" />
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <sweet-modal ref="warning_modal" hide-close-button overlay-theme="dark" icon="warning">{{warning_msg}}</sweet-modal>
        <sweet-modal ref="success_modal" hide-close-button overlay-theme="dark" icon="success">{{success_msg}}</sweet-modal>
        <create-reminder :from_notification="true" :reminderType="reminderType" v-if="createReminderShow" :mode_id="mode_id" :view_mode="view_mode" modal_name="createReminder" @hideCreateReminder="hideCreateReminder"></create-reminder>
    </div>
</template>

<script>
import { EventBus } from "./eventBus/nav-bar-event.js";
import { HalfCircleSpinner } from 'epic-spinners'
import CreateReminder from './Reminders/CreateReminder'
import notification from './mixins/notification'
import convert from './mixins/convert'
import { SweetModal } from 'sweet-modal-vue';
export default({
    mixins: [notification, convert],
    data(){
        return{
            success_msg:"",
            warning_msg:"",
            notifications_list: [],
            ajax_loader: false,
            notifications_count: 0,
            total_notifications_count: 0,
            createReminderShow: false,
            mode_id: '',
            view_mode: '',
            reminderType: '',
            found_note: false
        }
    },
    components:{
        CreateReminder,
        HalfCircleSpinner,
        SweetModal
    },
    methods:{
        async getNotifications(){
            this.ajax_loader = true
            let params = {
                "skip":this.notifications_count,
                "limit":10,
            }
            let response = await this.NotificationsList(params)
            this.notifications_list = response.response
            this.notifications_count = this.notifications_list.length
            this.total_notifications_count = response.count
            this.notifications_list.forEach((x) => {
                let d = new Date(x.created_date + ' ' + x.created_time);
                let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
                let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
                let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
                x['create_datetime'] = da + ' ' + mo + ' ' + ye + ' | ' + x.created_time
            })
            this.ajax_loader = false
        },
        async infiniteScroll(e) {
            const {
            target
            } = e;
            if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                try {
                    this.ajax_loader = true
                    let params = {
                        "skip":this.notifications_count,
                        "limit":10,
                    }
                    let response = await this.NotificationsList(params)
                    this.total_notifications_count = response.count
                    if (response.skip == this.notifications_count) {
                        let tempFiles = response.response
                        tempFiles.forEach((x) => {
                            let d = new Date(x.created_date + ' ' + x.created_time);
                            let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
                            let mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d);
                            let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
                            x['create_datetime'] = da + ' ' + mo + ' ' + ye + ' | ' + x.created_time
                        })
                        tempFiles.forEach(el => {
                            this.notifications_list.push(el)
                        })
                        this.notifications_list = this.notifications_list.filter((thing, index) => {
                            const payload = JSON.stringify(thing);
                            return index === this.notifications_list.findIndex(obj => {
                                return JSON.stringify(obj) === payload;
                            });
                        });
                        this.notifications_count += response.response.length
                        this.ajax_loader = false
                    }
                } catch (reason) {
                    this.ajax_loader = false
                }
            }
        },
        async viewReminder(id, type, is_read, note_id, is_cancelled){
            if(type == 'reminder'){
                if(is_read == false){
                    let res = await this.MarkAsRead({
                        id: note_id
                    })
                }
                this.mode_id = id
                this.reminderType = 'My Reminders'
                this.view_mode = 'view'
                if(is_cancelled == false){
                    this.createReminderShow = true;
                    setTimeout(() => {
                        this.$modal.show("createReminder")
                    }, 500);
                } else if(is_cancelled == true){
                    setTimeout(() => {
                        this.warning_msg = "This Reminder Has Been Cancelled"
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }, 1000);
                    
                } 
                this.notifications_count = 0
                //this.getNotifications();
                EventBus.$emit('RecallNotifications')
            }
        },
        hideCreateReminder(recall_api){
            this.createReminderShow = false;
            this.notifications_count = 0
            this.getNotifications()
        },
        // scrollToElementD(){
        //     var topPos = document.getElementById('inner-element').offsetTop;
        //     document.getElementById('container').scrollTop = topPos-10;
        // }
        scrollToBottom(node){
            node.scrollTop = node.scrollHeight;
        },
        async scrollDown(){
            const theElement = document.getElementById('scroller');
            theElement.scrollTop = theElement.scrollHeight
        }
    },
    computed:{
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
    },
    mounted(){
        EventBus.$on('ReloadNotification', (note_details) => {
            this.viewReminder(note_details.redirection_id, note_details.goto, note_details.is_read, note_details._id, note_details.is_cancelled)
        })
        EventBus.$on('ReloadNotificationToasted', (note_details) => {
            this.viewReminder(note_details.redirection_id, note_details.goto, note_details.is_read, note_details._id, note_details.is_cancelled)
        })
        EventBus.$on('closePopupReminder', () => {
            this.createReminderShow = false
        })
        EventBus.$on('RecallNotificationsPage', () => {
            this.notifications_count = 0
            this.getNotifications()
        })
    },
    created(){
        this.getNotifications();
        if(this.$route.query.note_details){
            let note_details = this.$route.query.note_details
            // setTimeout(() => {
            //     let found_item = this.notifications_list.some((y) => y._id == note_details._id)
            //     let i = 1
            //     while(found_item == false && i < 6){
            //         console.log(found_item)
            //         setTimeout(() => {
            //             console.log(this.notifications_list)
            //             this.scrollDown();
            //             found_item = this.notifications_list.some((y) => y._id == note_details._id)
            //             console.log(found_item)
            //         }, i*1000);
            //         i++
            //     }
            // }, 3000);
            this.viewReminder(note_details.redirection_id, note_details.goto, note_details.is_read, note_details._id, note_details.is_cancelled)
        }
    }
})
</script>

<style scoped>
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 20px;
    }
    .create-company-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
        border-radius: 6px;
    }
    .create-company-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
    .lead-aside {
        box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.41);
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        max-height:450px!important;
        overflow:scroll
    }

    .timeline {
        border-left: 2px solid #00448b;
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
        background: rgba(255, 255, 255, 0.03);
        color: rgba(255, 255, 255, 0.8);
        padding: 30px 48px 8px 0px !important;
        position: relative;
        line-height: 1.4em;
        overflow-x: initial;
        font-size: 14px;
        list-style: none;
        text-align: left;
        font-weight: 100;
        margin-left: 70px !important;
    }

    .timeline h3 {
        color: #303031 !important;
    }

    .timeline p {
        color: #303031 !important;
    }

    .timeline h1 {
        font-weight: 100;
        font-size: 1.4em;
    }

    .timeline h2,
    .timeline h3 {
        font-weight: 400;
        font-size: 16px;
    }

    .timeline .event {
        border-bottom: 1px dashed rgba(255, 255, 255, 0.1);
        padding-bottom: 25px;
        margin-bottom: 25px;
        position: relative;
    }

    .timeline .event:last-of-type {
        padding-bottom: 0;
        margin-bottom: 0;
        border: none;
    }

    .timeline .event:before,
    .timeline .event:after {
        position: absolute;
        display: block;
        top: 0;
    }

    .timeline .event:before {
        left: -217.5px;
        color: #303031 !important;
        content: attr(data-date);
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
    }

    .timeline .event:after {
        left: -22.6px;
        background: #ffffff;
        border-radius: 50%;
        height: 42px;
        width: 42px;
        content: "";
        top: 5px;
        border: 8px solid #00448b;
        box-shadow: 0 0 5px 0 #71acff;
    }

    .timeline .event-completed:after {
        font-family: 'fuse-iconfont';
        left: -22.6px;
        background: #34ac3d !important;
        border-radius: 50%;
        height: 42px;
        width: 42px;
        content: "\ea7b";
        color: #fff;
        padding-top: 5px;
        font-size: 28px;
        top: 5px;
        border: 6px solid #34ac3d !important;
        box-shadow: 0 0 5px 0 #34ac3d !important;
    }

    .timeline .event .today-span {
        left: -187.5px;
        color: #303031 !important;
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
        position: absolute;
        display: block;
        top: 0;
    }

    .timeline .event .date-span {
        left: -187.5px;
        color: #303031 !important;
        text-align: right;
        font-weight: 500;
        font-size: 0.9em;
        min-width: 120px;
        position: absolute;
        display: block;
        top: 19px;
    }
    .lead-status {
        box-shadow: 0 0 10px 0 #ededed;
        background-color: #fff;
        border-radius: 6px;
        width: 260px;
        height: auto;
        margin-left: 35px;
        border: solid 1px transparent;
    }
    .overflowing-broken-text{
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .lead-time {
        color: #837e7e;
        font-weight: 500;
    }
    .notification-illustrator{
        width:30%;
        min-width: 420px !important;
        height: 500px !important;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }
    .notification-illustrator h3{
        font-size: 25px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: 1.63px;
        text-align: center;
        color: rgba(0, 0, 0, 0.71);
    }
    /* .notes-list{
        width:70% !important;
        min-width:920px;
        position: relative;
    } */
    .note-box{
        box-shadow: 0 0 #0000, 0 0 #0000,0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px 0 rgba(0,0,0,.06);
        border-radius: 8px;
        background-color: #ededed !important;
        margin-bottom:20px;
        cursor: pointer;
    }
    .note-box.checked{
        background-color: #fff !important;
        box-shadow: 0 0 20px 0 #e1e7ee !important;
    }
    .notes-scroller{
        height:460px;
        overflow-y: auto;
        overflow-x: hidden
    }
    .overflow-x-auto{
        overflow-x: auto !important;
    }
    .pos-loader{
        position: absolute;
        top:85% !important;
        margin: 0 auto;
        left: 30%;
        right: 0;
    }
    .margin-auto-img{
        margin: auto;
        display: block;
    }

    .flex-auto {
    flex: 1 1 auto;
}
.min-h-0 {
    min-height: 0;
}
.z-10 {
    z-index: 10;
}
.relative {
    position: relative;
}
    .flex-col {
        flex-direction: column;
    }
    .notifyBlock {
        display: flex;
        flex-direction: column;
        min-width: 0px;
        min-height: 100%;
        position: relative;
        flex: 1 1 auto;
        width: 100%;
        height: auto;
        background-color: rgb(241, 245, 249);
    }
    .h-full {
        height: 100%;
    }
    .notifyBlock.notifyPageSimple-scroll-content {
        height: 100%;
    }
.notifyBlock .notifyPageSimple-wrapper {
    display: flex;
    flex-direction: row;
    flex: 1 1 auto;
    z-index: 2;
    min-width: 0px;
    height: 100%;
    background-color: #fff;
    inset: 0px;
    overflow: hidden;
}
@media (min-width: 1200px) {
    .notifyFlexAuto {
        flex: 0 0 auto;
    }
    .notifyBlock .notifyPageSimple-sidebarWrapper {
        overflow: hidden;
        background-color: transparent;
        position: absolute;
    }
    .notifyBlock .notifyPageSimple-sidebar.permanent {
        position: relative;
    }
}
.notifyBlock .notifyPageSimple-sidebarWrapper.permanent {
    position: relative;
    margin-left: 0px;
    margin-right: 0px;
    transition: margin 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms;
}

.notifyBlock .notifyPageSimple-leftSidebar {
    border-left: 0px;
}
.notifyBlock .notifyPageSimple-leftSidebar {
    width: 400px;
}
.notifyBlock .notifyPageSimple-sidebar {
    position: absolute;
    background-color: rgb(255, 255, 255);
    color: rgb(17, 24, 39);
    max-width: 100%;
    height: 100%;
}
.notifyDiv {
    background-color: rgb(255, 255, 255);
    color: rgb(17, 24, 39);
    transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    box-shadow: none;
    background-image: none;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1 0 auto;
    z-index: 1200;
    position: fixed;
    top: 0px;
    outline: 0px;
    left: 0px;
    border-right: 1px solid rgb(226, 232, 240);
}
.notifyScroll {
    overscroll-behavior: contain;
    min-height: 100%;
}
.notifyPageSimple-contentWrapper {
    display: flex;
    width: 100%;
    overflow: hidden;
}
.notifyPageSimple-contentWrapper .container {
    max-width: 1570px;
    width: 100%;
    margin: 0px auto;
}
.notifyPageSimple-content {
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    height: 100%;
    align-items: start;
    min-height: 0px;
}
.notifyPageSimple-sidebarContent {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}
.notification-text {
    object-fit: contain;
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 1.63px;
    text-align: center;
    color: rgba(0, 0, 0, 0.71);
}


@media (max-width: 900px) {
    .notifyBlock .notifyPageSimple-sidebar.permanent.closed {
        display: none;
    }
    .notifyBlock .notifyPageSimple-leftSidebar {
        width: 0px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Notifications.vue